<div class="dashboard row mb-3 g-3">
  <div class="col">
    <app-card-topups-balance-widget></app-card-topups-balance-widget>
  </div>
  <div class="col">
    <app-card-topups-balance-widget [isEmployeeCardBalance]="false"></app-card-topups-balance-widget>
  </div>
</div>
<div class="card shadow main-card">
  <div class="card-body">
    <app-table-header-template [searchOptions]="topUpSearchOptions">
      <ng-container filter>
        <app-recurring-topup-filter (query)="update($event)"></app-recurring-topup-filter>
      </ng-container>
      <ng-container buttons>
        <button
          (click)="onCreate()"
          id="createRecurringRuleButton"
          class="btn btn-primary btn-sm">
          Create rule
        </button>
      </ng-container>
    </app-table-header-template>

    <app-table
      [pageSize]="8"
      [columns]="columns"
      [getDataCallback]="getData"
      class="table-recurring-topups"
      emptyMessage="Your card top-ups will appear here.">
      <ng-template
        #cardNumberCell
        let-value="value"
        let-row="row">
        <app-card-number-display
          [value]="value"
          [status]="row.card.status"></app-card-number-display>
      </ng-template>
      <ng-template
        #cardNameCell
        let-value="value"
        let-row="row">
        @if (row.card.type === CardType.Personal) {
          Employee Card
        } @else {
          {{ value | emptyIndicator }}
        }
      </ng-template>
      <ng-template
        #cardHolderCell
        let-row="row"
        let-value="value">
        {{ value }} {{ row.employee.last_name }}
      </ng-template>
      <ng-template
        #frequencyCell
        let-value="value">
        @if (value === TopUpFrequency.Daily) {
          {{ TopUpFrequencyLabel.DAILY }}
        }
        @if (value === TopUpFrequency.Weekly) {
          {{ TopUpFrequencyLabel.WEEKLY }}
        }
        @if (value === TopUpFrequency.Monthly) {
          {{ TopUpFrequencyLabel.MONTHLY }}
        }
      </ng-template>
      <ng-template
        class="text-end"
        #amountCell
        let-value="value">
        <span class="fw-semibold">
          {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
        </span>
      </ng-template>
      <ng-template
        #actionsCell
        let-row="row">
        <button
          class="btn-action"
          title="Edit rule"
          (click)="editRule(row.id)">
          <i class="iconoir-edit-pencil"></i>
        </button>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
